import {
    formatOutOf,
    formatYesNo,
    getScale,
    getScales,
    mapRiskLabel,
    type OutcomeTableColumn,
    type OutcomeTableConfig,
} from '../helpers';

const CABI_SCALES: Array<{ key: string; label: string; max: number }> = [
    { key: 'somatic', label: 'Somático (itens 1-4)', max: 8 },
    { key: 'anxiety', label: 'Ansiedade (itens 5-10)', max: 12 },
    { key: 'phobias', label: 'Fobias (item 11)', max: 2 },
    { key: 'obsessive_compulsive', label: 'Obsessivo-compulsivo (itens 12-15)', max: 8 },
    { key: 'insecurity', label: 'Insegurança (itens 16-17)', max: 4 },
    { key: 'post_traumatic_stress', label: 'Estresse pós-traumático (item 18)', max: 2 },
    { key: 'depression', label: 'Depressão (itens 19-28)', max: 20 },
    { key: 'irritability', label: 'Irritabilidade (itens 29-32)', max: 8 },
    { key: 'oppositional_defiant', label: 'Desafiador-opositor (itens 33-37)', max: 10 },
    { key: 'conduct_disorder', label: 'Transtorno de conduta (itens 38-42)', max: 10 },
    { key: 'impulsivity', label: 'Impulsividade (itens 43-45)', max: 6 },
    { key: 'hyperactivity', label: 'Hiperatividade (itens 46-48)', max: 6 },
    { key: 'inattention', label: 'Desatenção (itens 49-51)', max: 6 },
    { key: 'reality_check', label: 'Teste de realidade (itens 52-55)', max: 8 },
    { key: 'relationships', label: 'Relacionamentos (itens 56-61)', max: 12 },
    { key: 'enuresis_encopresis', label: 'Enurese/Encoprese (itens 62-63)', max: 4 },
    { key: 'bulimia', label: 'Bulimia (item 64)', max: 2 },
    { key: 'anorexia', label: 'Anorexia (itens 65-67)', max: 6 },
    { key: 'sex', label: 'Sexo (itens 68-69)', max: 4 },
    { key: 'substance_abuse', label: 'Uso de substâncias (itens 70-72)', max: 6 },
    { key: 'school_problems', label: 'Problemas escolares (itens 73-74)', max: 4 },
    { key: 'bullying', label: 'Bullying - vitimização (item 75)', max: 2 },
    { key: 'internalizing', label: 'Composto Internalizante', max: 38 },
    { key: 'externalizing', label: 'Composto Externalizante', max: 20 },
    { key: 'adhd', label: 'Composto TDAH', max: 18 },
];

const cabiColumns: OutcomeTableColumn[] = [
    { key: 'scale', label: 'Escala' },
    { key: 'score', label: 'Pontuação' },
    { key: 'observation', label: 'Observação' },
];

export const cabiConfig: OutcomeTableConfig = {
    title: 'Resultados CABI',
    columns: cabiColumns,
    getRows: (outcomes) => {
        const scales = getScales(outcomes);
        const risk = getScale(scales, 'risk');

        const scaleRows = CABI_SCALES.map(({ key, label, max }) => ({
            scale: label,
            score: formatOutOf(getScale(scales, key).raw, max),
        }));

        return [
            ...scaleRows,
            {
                scale: 'Ideação de não querer mais viver (item 27)',
                score: formatYesNo(risk.suicidal_ideation_flag),
                observation: mapRiskLabel(risk.suicidal_ideation_flag),
            },
            {
                scale: 'Machucou-se ou tentou se machucar (item 28)',
                score: formatYesNo(risk.self_harm_flag),
                observation: mapRiskLabel(risk.self_harm_flag),
            },
        ];
    },
    match: (outcomes) => {
        const scales = getScales(outcomes);
        return (
            'internalizing' in scales &&
            'externalizing' in scales &&
            'self_harm_flag' in getScale(scales, 'risk')
        );
    },
};
